(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.FMTCartVisit = api; api.mount(root); }
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var KEY = 'fmt_cart_visit_v1', IDLE = 60 * 60 * 1000;
  function recent(record, time) { return record && Number.isSafeInteger(record.lastActivity) && record.lastActivity > 0 && record.lastActivity <= time && time - record.lastActivity < IDLE; }
  function create(options) {
    var storage = options.storage, clock = options.now || Date.now, memory = null, cart = null;
    function read(key) { try { return JSON.parse(storage.getItem(key)); } catch (_) { return null; } }
    memory = read(KEY);
    // Existing same-tab builder visits can adopt the new cart policy on upgrade.
    if (!memory) {
      var builder = read('fmt_builder_visit_v1');
      if (builder && builder.version === 1 && recent(builder, clock())) memory = { lastActivity: builder.lastActivity, pending: false };
    }
    function save(pending) {
      memory = { lastActivity: clock(), pending: pending };
      try { storage.setItem(KEY, JSON.stringify(memory)); } catch (_) {}
    }
    async function request(path, body) {
      var response = await options.fetch((options.root || '/') + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      var data;
      try { data = await response.json(); } catch (_) { throw Error('We could not read your saved cart. Please try again.'); }
      if (!response.ok || !data || !Array.isArray(data.items)) throw Error('We could not update your saved cart. Please try again.');
      return data;
    }
    function pending() { return !!cart && cart.items.length > 0 && (!recent(memory, clock()) || memory.pending); }
    async function check() {
      cart = await request('cart.js');
      save(pending());
      return { pending: memory.pending, cart: cart };
    }
    return {
      check: check,
      pending: pending,
      acknowledge: function () { save(false); },
      touch: function () { if (recent(memory, clock()) && !memory.pending) save(false); },
      startNewProject: async function () {
        await check();
        await this.empty();
      },
      empty: async function () {
        // Only remove the line keys the customer just reviewed, never clear an
        // unrelated item added in another tab while the dialog was open.
        if (!cart) throw Error('Review your saved cart before emptying it.');
        var updates = {};
        cart.items.forEach(function (item) { if (typeof item.key !== 'string') throw Error('We could not identify a saved item. Please review your cart.'); updates[item.key] = 0; });
        if (Object.keys(updates).length) await request('cart/update.js', { updates: updates });
        cart = await request('cart.js');
        if (cart.items.length) { save(true); throw Error('Your cart changed in another tab. Please review the remaining items before continuing.'); }
        save(false);
      }
    };
  }
  function mount(win) {
    var doc = win.document, storage;
    try { storage = win.sessionStorage; } catch (_) {}
    var service = create({ storage: storage, fetch: win.fetch.bind(win), root: win.Shopify && win.Shopify.routes ? win.Shopify.routes.root : '/' });
    var busy = false, dialog = null, refreshPromise = null;
    function paint(pending) {
      doc.documentElement.classList.toggle('fmt-cart-pending', pending);
      var link = doc.getElementById('cart-icon-bubble');
      if (link) {
        link.toggleAttribute('data-saved-cart', pending);
        var label = link.querySelector('.fmt-icon-label');
        if (label) label.textContent = pending ? 'Saved cart' : 'Cart';
        link.setAttribute('aria-label', pending ? 'Review your saved cart from an earlier visit' : 'Cart');
      }
      var banner = doc.getElementById('fmt-saved-cart-banner');
      if (banner) banner.hidden = !pending;
    }
    async function refresh() {
      if (!refreshPromise) refreshPromise = service.check().then(function (value) { paint(value.pending); return value; }).finally(function () { refreshPromise = null; });
      return refreshPromise;
    }
    function choose(checkout) {
      if (dialog) return Promise.resolve(false);
      return new Promise(function (resolve) {
        var previous = doc.activeElement;
        dialog = doc.createElement('dialog');dialog.className = 'fmt-saved-cart-dialog';
        dialog.setAttribute('aria-labelledby', 'fmt-saved-cart-title');dialog.setAttribute('aria-describedby', 'fmt-saved-cart-description');
        dialog.innerHTML = '<button type="button" data-close aria-label="Close saved cart choices">Close ✕</button><h2 id="fmt-saved-cart-title">You have a saved cart</h2><p id="fmt-saved-cart-description">' +
          (checkout ? 'Items from an earlier visit are still in your cart. Review those items, or replace them with this estimate before checkout.' : 'These items are from an earlier visit. Review them, or empty this cart to start a new estimate. Placed orders are not affected.') +
          '</p><button type="button" data-review>Review saved cart</button><button type="button" data-empty>' + (checkout ? 'Replace saved cart with this estimate' : 'Empty cart and start again') + '</button><p role="alert" hidden></p>';
        doc.body.appendChild(dialog);
        function finish(value) {
          var current = dialog;dialog = null;current.close();current.remove();
          if (previous && previous.isConnected) previous.focus();resolve(value);
        }
        dialog.querySelector('[data-close]').onclick = function () { if (!busy) finish(false); };
        dialog.addEventListener('cancel', function (e) { e.preventDefault();if (!busy) finish(false); });
        dialog.querySelector('[data-review]').onclick = function () { service.acknowledge();paint(false);finish(false);win.location.assign((win.Shopify && win.Shopify.routes ? win.Shopify.routes.root : '/') + 'cart'); };
        dialog.querySelector('[data-empty]').onclick = async function () {
          if (busy) return;busy = true;
          dialog.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          var alert = dialog.querySelector('[role=alert]');alert.hidden = true;
          try {
            await service.empty();paint(false);
            doc.querySelectorAll('.cart-count-bubble').forEach(function (b) { b.remove(); });
            if (!checkout) {
              try { storage.removeItem('fmt_builder_visit_v1'); } catch (_) {}
              finish(false);win.location.assign('/pages/start-order');
            } else finish(true);
          } catch (error) {
            alert.textContent = error.message;alert.hidden = false;
            dialog.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
          } finally { busy = false; }
        };
        dialog.showModal();dialog.querySelector('[data-review]').focus();
      });
    }
    api.beforeCheckout = async function () { var value = await refresh();return !value.pending || await choose(true); };
    api.startNewProject = async function () {
      if (busy) throw Error('Your cart is being updated. Please try again in a moment.');
      busy = true;
      try {
        if (refreshPromise) await refreshPromise;
        await service.startNewProject();
        paint(false);
        doc.querySelectorAll('.cart-count-bubble').forEach(function (bubble) { bubble.remove(); });
      } finally { busy = false; }
    };
    // Capture before the theme's cart drawer handler so stale carts get a choice.
    doc.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('#cart-icon-bubble');
      if (link && service.pending()) { event.preventDefault();event.stopImmediatePropagation();paint(true);choose(false); }
    }, true);
    var lastTouch = 0;
    function activity(event) {
      if (!event.isTrusted || Date.now() - lastTouch < 30000) return;
      lastTouch = Date.now();service.touch();if (service.pending()) paint(true);
    }
    doc.addEventListener('pointerdown', activity, { passive: true });doc.addEventListener('keydown', activity);
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) refresh().catch(function () {}); });
    win.addEventListener('pageshow', function (event) { if (event.persisted) refresh().catch(function () {}); });
    var header = doc.querySelector('.section-header');
    if (header && win.ResizeObserver) new win.ResizeObserver(function () { doc.documentElement.style.setProperty('--fmt-header-offset', header.getBoundingClientRect().height + 'px'); }).observe(header);
    // Cover direct cart visits as well as the header link.
    if (/\/cart\/?$/.test(win.location.pathname)) {
      var banner = doc.createElement('aside');banner.id = 'fmt-saved-cart-banner';banner.className = 'fmt-saved-cart-banner';banner.hidden = true;
      banner.innerHTML = '<p><strong>This cart is from an earlier visit.</strong> Check the items below before ordering.</p><button type="button" data-keep>Keep these items</button><button type="button" data-choose>Empty cart and start again</button>';
      var main = doc.getElementById('MainContent');if (main) main.prepend(banner);
      banner.querySelector('[data-keep]').onclick = function () { service.acknowledge();paint(false); };
      banner.querySelector('[data-choose]').onclick = function () { choose(false); };
    }
    // Cosmetic updates to a Shopify cart section must not restore an old badge.
    var headerIcons = doc.querySelector('.header__icons');
    if (headerIcons && win.MutationObserver) new win.MutationObserver(function (changes) {
      if (changes.some(function (c) { return Array.from(c.addedNodes).some(function (n) { return n.nodeType === 1 && (n.matches('.cart-count-bubble, .fmt-icon-label') || n.querySelector('.cart-count-bubble')); }); })) paint(service.pending());
    }).observe(headerIcons, { childList: true, subtree: true });
    refresh().catch(function () { paint(false); });
  }
  var api = { create: create, mount: mount, key: KEY, maxIdleMs: IDLE };
  return api;
}));
